module.exports = __webpack_public_path__ + "img/s02-min.c702b561.png";